import React from 'react';
import { styled, useTheme } from '@mui/material';

// components
import AddToCart from '../../../../../../_assets/svg/AddToCart.svg';
import { SquareButton } from '../../../../../../components/Buttons/SquareButton';
import { maxNumberQuotesInCart } from '../../constants';
import useNotifications from '../../../../../../_lib/notifications/useNotifications';

interface Props {
  onClick: () => void;
  quoteCount: number;
}

const Cart = ({ onClick, quoteCount }: Props) => {
  const { palette } = useTheme();
  const notifications = useNotifications();

  React.useEffect(() => {
    if (quoteCount >= maxNumberQuotesInCart) {
      notifications.show({
        type: 'info',
        title: 'You have reached your cart limit.',
        position: 'bottom-right',
      });
    }
  }, [notifications, quoteCount]);

  return (
    <CartContainer>
      <SquareButton
        variant="outlined"
        style={{ width: '2.86rem', height: '2.86rem' }}
        onClick={onClick}
      >
        <div>
          <CartTotal data-testid="cart-total">{quoteCount}</CartTotal>
          <AddToCart
            fill={palette.primary.contrastText}
            style={{ fontSize: '1.7rem' }}
          />
        </div>
      </SquareButton>
    </CartContainer>
  );
};

const CartContainer = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  };
});

const CartTotal = styled('span')(({ theme }: { theme: any }) => {
  return {
    position: 'absolute',
    top: -2,
    left: '50%',
    color: theme.palette.common.cowbellBlue,
    fontSize: '1.2rem',
    fontWeight: 600,
    transform: 'translateX(-10%)',
  };
});

export default Cart;
